module.exports = __webpack_public_path__ + "img/coupon-sharee-bg.5f14a57.png";